export const TRIAL_STATUS_LABELS = {
  not_started: "No iniciado",
  active: "Activo",
  ending_soon: "Por vencer",
  expired: "Vencido",
  extended: "Extendido",
  converted: "Convertido",
  lost: "Perdido",
  paused: "Pausado",
  declined: "Declinado",
};

export const CONVERSION_READINESS_LABELS = {
  insufficient_data: "Datos insuficientes",
  not_ready: "No listo",
  needs_attention: "Requiere atención",
  promising: "Prometedor",
  ready_to_convert: "Listo para convertir",
  converted: "Convertido",
  lost: "Perdido",
};

export const CONVERSION_STAGE_LABELS = {
  no_conversation: "Sin conversación",
  value_review_scheduled: "Revisión agendada",
  value_review_completed: "Revisión completada",
  pricing_discussed: "Pricing discutido",
  proposal_sent: "Propuesta enviada",
  negotiation: "Negociación",
  converted: "Convertido",
  lost: "Perdido",
};

export const LOST_REASON_LABELS = {
  no_value_seen: "No vio valor",
  too_expensive: "Muy caro",
  dealer_unresponsive: "Dealer no responde",
  insufficient_leads: "Pocos leads",
  poor_lead_quality: "Mala calidad leads",
  inventory_not_ready: "Inventario no listo",
  chose_competitor: "Eligió competidor",
  not_interested: "No interesado",
  other: "Otro",
};

export const TRIAL_SUBQUEUES = [
  { key: "all", label: "Todos", href: "/admin/dealers/trials" },
  { key: "active", label: "Activos", href: "/admin/dealers/trials/active" },
  { key: "ending-soon", label: "Por vencer", href: "/admin/dealers/trials/ending-soon" },
  { key: "ready-to-convert", label: "Listos", href: "/admin/dealers/trials/ready-to-convert" },
  { key: "needs-attention", label: "Atención", href: "/admin/dealers/trials/needs-attention" },
];

export function trackDealerTrialEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[dealer-trial-event]", eventType, metadata);
  }
}

export function readinessBadgeClass(label) {
  if (label === "ready_to_convert") return "badge badge--success";
  if (label === "needs_attention" || label === "not_ready") return "badge badge--warning";
  if (label === "lost") return "badge badge--danger";
  return "badge badge--muted";
}
